module.exports = __webpack_public_path__ + "static/media/copyrights.9fcad5f8.png";